import React = require("react")
import { SearchBarProps } from "./searchBarState"

export const SearchBar = (props: SearchBarProps) => <form onSubmit={(e) => {
  e.preventDefault()
  props.runSearchQuery()
}}>
  <input id={props.id} type="text" className="form__input search__input" placeholder="Zoeken"
    value={props.query}
    onChange={e => props.updateSearchQuery(e.target.value)}
  />
  <button type="submit" className="button button--primary button--arrow search__button">
    <span className="button__label">Zoeken</span>
  </button>
  <svg className="form__icon" width="20px" height="20px" aria-hidden="true"><use xlinkHref="#icon--search-flevo" /></svg>
</form>
